import * as angular from "angular";
import {IController} from "angular";
import {TextTemplatePurposeType} from "../../../text-templates/types/text-template-purpose.type";

export class notificationsTableCtrl implements IController {

  purpose: TextTemplatePurposeType;
  onEdit: Function;

  public textTemplatePurposeType: typeof TextTemplatePurposeType = TextTemplatePurposeType;

  constructor() {
  }

}

angular
  .module('bringoz.admin.notifications')
  .component('notificationsTable', {
    bindings: {
      notifications: '<',
      language: '<',
      purpose: '<?',
      onEdit: '&'
    },
    template: require('./notifications-table.html').default,
    controller: notificationsTableCtrl
  });
